import { Coach, CoachesDataTableModel } from '../../../../types/coaches'

export enum DARIO_COACHES_ACTION_TYPES {
	SET_COACHES = 'SET_COACHES',
	SET_SEARCH = 'SET_SEARCH',
	SET_EXPERTISES = 'SET_EXPERTISES',
	SET_LANGUAGES = 'SET_LANGUAGES',
	SET_ORGANIZATIONS = 'SET_ORGANIZATIONS',
	SET_ROLES = 'SET_ROLES',
	SET_TIERS = 'SET_TIERS',
	SET_STATUSES = 'SET_STATUSES',
	SET_SELECTED = 'SET_SELECTED',
}

interface CoachesListAction {
	type: DARIO_COACHES_ACTION_TYPES.SET_COACHES
	payload: Array<Coach>
}

interface CoachesSetSearchAction {
	type: DARIO_COACHES_ACTION_TYPES.SET_SEARCH
	payload: string
}

interface CoachesSetExpertisesAction {
	type: DARIO_COACHES_ACTION_TYPES.SET_EXPERTISES
	payload: string[]
}

interface CoachesSetLanguagesAction {
	type: DARIO_COACHES_ACTION_TYPES.SET_LANGUAGES
	payload: string[]
}

interface CoachesSetOrganizationsAction {
	type: DARIO_COACHES_ACTION_TYPES.SET_ORGANIZATIONS
	payload: string[]
}

interface CoachesSetRolesAction {
	type: DARIO_COACHES_ACTION_TYPES.SET_ROLES
	payload: string[]
}

interface CoachesSetTiersAction {
	type: DARIO_COACHES_ACTION_TYPES.SET_TIERS
	payload: string[]
}

interface CoachesSetStatusesAction {
	type: DARIO_COACHES_ACTION_TYPES.SET_STATUSES
	payload: string[]
}

interface CoachesSetSelectedAction {
	type: DARIO_COACHES_ACTION_TYPES.SET_SELECTED
	payload: Array<CoachesDataTableModel>
}

export interface CoachesState {
	coaches: Array<Coach>
	search: string
	expertises: string[]
	languages: string[]
	organizations: string[]
	roles: string[]
	tiers: string[]
	statuses: string[]
	selectedCoaches: Array<CoachesDataTableModel>
}

const initialState: CoachesState = {
	coaches: [],
	search: '',
	expertises: [],
	languages: [],
	organizations: [],
	roles: [],
	tiers: [],
	statuses: [],
	selectedCoaches: [],
}

type coachesActions =
	| CoachesListAction
	| CoachesSetSearchAction
	| CoachesSetExpertisesAction
	| CoachesSetLanguagesAction
	| CoachesSetOrganizationsAction
	| CoachesSetRolesAction
	| CoachesSetTiersAction
	| CoachesSetStatusesAction
	| CoachesSetSelectedAction

export default (state = initialState, action: coachesActions): CoachesState => {
	switch (action.type) {
		case DARIO_COACHES_ACTION_TYPES.SET_COACHES: {
			return {
				...state,
				coaches: action.payload || [],
			}
		}

		case DARIO_COACHES_ACTION_TYPES.SET_SEARCH: {
			return {
				...state,
				search: action.payload || '',
			}
		}

		case DARIO_COACHES_ACTION_TYPES.SET_EXPERTISES: {
			return {
				...state,
				expertises: [...action.payload],
			}
		}

		case DARIO_COACHES_ACTION_TYPES.SET_LANGUAGES: {
			return {
				...state,
				languages: [...action.payload],
			}
		}

		case DARIO_COACHES_ACTION_TYPES.SET_ORGANIZATIONS: {
			return {
				...state,
				organizations: [...action.payload],
			}
		}

		case DARIO_COACHES_ACTION_TYPES.SET_ROLES: {
			return {
				...state,
				roles: [...action.payload],
			}
		}

		case DARIO_COACHES_ACTION_TYPES.SET_TIERS: {
			return {
				...state,
				tiers: [...action.payload],
			}
		}

		case DARIO_COACHES_ACTION_TYPES.SET_STATUSES: {
			return {
				...state,
				statuses: [...action.payload],
			}
		}

		case DARIO_COACHES_ACTION_TYPES.SET_SELECTED: {
			return {
				...state,
				selectedCoaches: [...action.payload],
			}
		}

		default: {
			return state
		}
	}
}
